export type AppRoute =
  | { kind: "public" }
  | { kind: "admin"; workspace: "bookings" | "events" | "health" | "proposals" | "legacy" }
  | { kind: "proposal"; token: string }
  | { kind: "manage"; reference: string; managementToken: string };

export function parseAppRoute(search: string): AppRoute {
  const params = new URLSearchParams(search);
  const admin = params.get("admin");

  if (admin === "events") return { kind: "admin", workspace: "events" };
  if (admin === "health") return { kind: "admin", workspace: "health" };
  if (admin === "proposals") return { kind: "admin", workspace: "proposals" };
  if (admin === "1") return { kind: "admin", workspace: "bookings" };
  if (admin === "legacy") return { kind: "admin", workspace: "legacy" };

  const proposalToken = normalize(params.get("proposal"));
  if (proposalToken) return { kind: "proposal", token: proposalToken };

  const reference = normalize(params.get("reference"));
  const managementToken = normalize(params.get("manage"));

  if (reference && managementToken) {
    return { kind: "manage", reference, managementToken };
  }

  return { kind: "public" };
}

function normalize(value: string | null): string | undefined {
  const normalized = value?.trim();
  return normalized || undefined;
}
